module.exports = __webpack_public_path__ + "img/2024-08-29c_3.4e649071.jpg";